import React from 'react';
import LabelField from '../Label/LabelField';

const PhoneField = ({
  label,
  type = 'text',
  name,
  value,
  onChange,
  error,
  placeholder,
  isPhone = false,
  country_code = '+91',
  className,
  onCountryCodeChange = () => {},
  ...rest
}) => {
  return (
    <div className="mb-3">
      {label && <LabelField label={label} />}
      <div className="input-group">
        {isPhone && (
          <select
            className={`form-select country-code-select ${className}`}
            value={country_code}
            onChange={onCountryCodeChange}
          >
            <option value="+91">+91</option>
            <option value="+1">+1</option>
            <option value="+44">+44</option>
            {/* Add more countries as needed */}
          </select>
        )}
        <input
          type={type}
          className="form-control"
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          {...rest}
        />
      </div>
      {error && <div className="invalid-feedback d-block">{error}</div>}
    </div>
  );
};

export default PhoneField;
